import { render, staticRenderFns } from "./AutocompleteAndCreate.vue?vue&type=template&id=1a4bd4f1&scoped=true"
import script from "./AutocompleteAndCreate.vue?vue&type=script&lang=js"
export * from "./AutocompleteAndCreate.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteAndCreate.vue?vue&type=style&index=0&id=1a4bd4f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bd4f1",
  null
  
)

export default component.exports